import { Pipe, PipeTransform } from '@angular/core'
import { getPerfilByKey } from 'src/app/shared/enums/perfil.enum'

@Pipe({
  standalone: true,
  name: 'perfil',
})
export class PerfilPipe implements PipeTransform {
  transform(value: string[] | string): string {
    let values: string[] = []
    if (typeof value === 'string' || value instanceof String) {
      values.push(value.toString())
    } else {
      values = value
    }
    let perfis = ''
    values.forEach(perfil => {
      let perfilReplace = getPerfilByKey(perfil)
      if (perfilReplace === undefined) {
        perfis += perfil + ', '
      } else {
        perfis += perfilReplace + ', '
      }
    })
    if (perfis !== '') {
      perfis = perfis.slice(0, -2)
    }
    return perfis
  }
}
